import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// beacon-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate (store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate (store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearBeacon (store) {
    store.commit('clearBeacon')
  },
  async addBeacon (store) {
    store.state.addBeacon['companyId'] = master.state.loginCompanyId
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        store.state.addBeacon
      ]
    }
    await Vue.http.post(URL + '/Locations/Beacon/Edit', data, config)
    // 成功
    // 追加後の処理
    await store.dispatch('setBeacons')
  },
  async setBeacons (store) {
    store.state.beacons = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          mode: '1',
          companyId: store.state.companyId
        }
      ]
    }
    var response = await Vue.http.post(URL + '/Locations', data, config)
    // 成功
    store.commit('setBeacons', response)
  },
  async updateBeacon (store) {
    if (store.state.updateBeacon.major == null) {
      store.state.updateBeacon.major = store.state.beacon.major
    }
    if (store.state.updateBeacon.minor == null) {
      store.state.updateBeacon.minor = store.state.beacon.minor
    }
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          mode: '2',
          beacons: [
            store.state.updateBeacon
          ]
        }
      ]
    }
    var response = await Vue.http.post(URL + '/Locations/Beacon/Maintenance', data, config)
    // 成功
    // 更新後の処理
    store.commit('setBeacons', response)
  },
  async deleteBeacons (store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          mode: '3',
          beacons: payload
        }
      ]
    }
    var response = await Vue.http.post(URL + '/Locations/Beacon/Maintenance', data, config)
    // 成功
    // 削除後の処理
    store.commit('setBeacons', response)
  },
  async setDetailBeacon (store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          locationId: payload.locationId
        }
      ]
    }
    var response = await Vue.http.post(URL + '/Locations', data, config)
    // 成功
    store.commit('setDetail', response)
  },
  async importBeacons (store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: payload
    }
    await Vue.http.post(URL + '/Locations/Beacon/Edit', data, config)
    // 成功
    // 追加後の処理
    await store.dispatch('setBeacons')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/beaconModules/actions.js